import {
    COMPANIES_REQUEST,
    COMPANIES_SUCCESS,
    COMPANIES_FAIL,
    COMPANIES_MCPF_REQUEST,
    COMPANIES_MCPF_SUCCESS,
    COMPANIES_MCPF_FAIL,
    COMPANY_APPROVE_REQUEST,
    COMPANY_APPROVE_SUCCESS,
    COMPANY_APPROVE_FAIL,
    COMPANY_BLOCK_REQUEST,
    COMPANY_BLOCK_SUCCESS,
    COMPANY_BLOCK_FAIL,
    COMPANY_UPDATE_ACCESS_REQUEST,
    COMPANY_UPDATE_ACCESS_SUCCESS,
    COMPANY_UPDATE_ACCESS_FAIL,
    SHOW_POPUP,
    HIDE_PROGRESS,
    SHOW_PROGRESS,
} from '../constants/action-types';

import {
    getCompaniesRequest,
    getCompaniesByMarketsRequest,
    blockCompanyRequest,
    updateCompanyAccessRequest,
    deleteCompanyRequest,
} from '../services/api';

export function getCompanies(cb) {
    return (dispatch) => {
        getCompaniesByMarketsRefresh(dispatch, cb);
    }
}

export function getApprovedCompanies(cb, marketId) {
    return (dispatch) => {
        getApprovedCompaniesRefresh(dispatch, cb, marketId);
    }
}

export function updateCompanyAccess(id, type) {
    return (dispatch) => {
        dispatch({ type: COMPANY_UPDATE_ACCESS_REQUEST });
        updateCompanyAccessRequest(id, type).then( result => {
            dispatch({type: COMPANY_UPDATE_ACCESS_SUCCESS});
            getCompaniesByMarketsRefresh(dispatch);
        }).catch( error => {
            dispatch({
                type: COMPANY_UPDATE_ACCESS_FAIL,
                payload: error
            });
        });
    }
}

export function deleteCompany(id, name, refreshCompanies) {
    return (dispatch) => {
        dispatch({
            type: SHOW_POPUP,
            popupProps: {
                title: 'Delete company!',
                content: 'You are about to delete '+name+' - Do you wish to proceed?',
                isConfirm: true,
                buttonAction: () => {
                    dispatch({type: SHOW_PROGRESS});
                    deleteCompanyRequest(id).then( result => {
                        dispatch({type: HIDE_PROGRESS});
                        refreshCompanies();
                    }).catch(error => {
                        dispatch({type: HIDE_PROGRESS});
                        console.log(error);
                    });
                }
            }
        });
    }
}

const getCompaniesRefresh = (dispatch, cb) => {
    dispatch({ type: COMPANIES_REQUEST });
    return getCompaniesRequest().then( result => {
        dispatch({
            type: COMPANIES_SUCCESS,
            payload: result.data
        });
        if (cb && typeof cb == 'function') cb();
    }).catch( error => {
        dispatch({
            type: COMPANIES_FAIL,
            payload: error
        });
    });
}

const getCompaniesByMarketsRefresh = (dispatch, cb) => {
    dispatch({ type: COMPANIES_REQUEST });
    return getCompaniesByMarketsRequest().then( result => {
        dispatch({
            type: COMPANIES_SUCCESS,
            payload: result.data
        });
        if (cb && typeof cb == 'function') cb();
    }).catch( error => {
        dispatch({
            type: COMPANIES_FAIL,
            payload: error
        });
    });
}

const getApprovedCompaniesRefresh = (dispatch, cb, marketId) => {
    dispatch({ type: COMPANIES_MCPF_REQUEST });
    return getCompaniesRequest(true, marketId).then( result => {
        dispatch({
            type: COMPANIES_MCPF_SUCCESS,
            payload: result.data
        });
        if (cb && typeof cb == 'function') cb();
    }).catch( error => {
        dispatch({
            type: COMPANIES_MCPF_FAIL,
            payload: error
        });
    });
}



// WEBPACK FOOTER //
// ./source/actions/companiesActions.js